import { atom, selector } from "recoil";
import { createDataRequest, updateDataRequest } from "../../../api/controller/TodoController";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";

export const todoListState = atom({
    key: 'todoListState',
    default: [],
})

/** Open (incomplete) todo count for sidebar badge; refreshed from VerticalLayout. */
export const todoOpenCountState = atom({
    key: 'todoOpenCountState',
    default: 0,
})


export const modalConfigDefault = { size: "md", wizard: false }

export const filtersDefault = [
    {
        label: 'Completed',
        size: 6,
        offset: 6,
        required: true,
        type: 'select', // date, dateRange & select only
        value: { label: "No", value: false }, // String date "yyyy-mm-dd" for date | Array of 2 dates for dateRange | Object as shown for Select { label: "Label", value: 0 }
        list: [
            { label: 'Yes', value: true },
            { label: 'No', value: false },
        ]
    },
]

export const formModes = {
    create: [ { name: 'Default Create', action: createDataRequest } ], 
    update: [ { name: 'Default Update', action: updateDataRequest } ],
    view: [ { name: 'Default View' } ],
}

export const todoDataStructureState = selector({
    key: 'todoDataStructureState',
    get: ({ get }) => (
        [

            { 
                label: 'Title',
                type: 'text',
                order: { table: 1, form: 1 }, 
				table: { editable: true },
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: [{ enabled: false }], view: ['same_as:update.0'], 
            },
			{ 
                label: 'Description',
                type: 'text',
                order: { table: 2, form: 2 }, 
				table: { editable: true },
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: [{ enabled: false }], view: ['same_as:update.0'], 
            },
			{ 
                label: 'Completed',
                type: 'switch',
                order: { table: 3, form: 3 }, 
				table: { editable: true },
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: [{ enabled: false }], view: ['same_as:update.0'], 
				list: ['Yes', 'No'],
            },

        ].filter((v)=>{
            const page = get(pageState)
            const permissions = get(permissionState)
            if(! v.permission){
                return true
            }
            let absolute = false;
            if(v.permission.substr(0,1) === ":"){
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
})
